import FacebookIcon from "@/assets/svg/SocialMedia/FacebookIcon";
import InstagramIcon from "@/assets/svg/SocialMedia/InstagramIcon";
import LinkedInIcon from "@/assets/svg/SocialMedia/LinkedInIcon";
import TwitterIconSvg from "@/assets/svg/SocialMedia/TwitterIconSvg";

export type SocialKey = "twitter" | "facebook" | "instagram" | "linkedin";

export const socialOptions: { name: string; icon: any; key: SocialKey }[] = [
  { name: "Twitter", icon: TwitterIconSvg, key: "twitter" },
  { name: "Facebook", icon: FacebookIcon, key: "facebook" },
  { name: "Instagram", icon: InstagramIcon, key: "instagram" },
  { name: "LinkedIn", icon: LinkedInIcon, key: "linkedin" },
];
